import angular from "angular";

// Define Error Prefix
const COMMON_PREFIX = 3000;

// Define Error Codes
const MISSING_FIRST_NAME = COMMON_PREFIX + 1;
const MISSING_LAST_NAME = COMMON_PREFIX + 2;
const MISSING_COMPANY_NAME = COMMON_PREFIX + 3;

// Public Error Codes
export const COMMON_ERRORS = {
  MISSING_FIRST_NAME,
  MISSING_LAST_NAME,
  MISSING_COMPANY_NAME,
};

// Corresponding Error Messages
export const COMMON_ERROR_MESSAGES = {
  [MISSING_FIRST_NAME]: "First name is required.",
  [MISSING_LAST_NAME]: "Last name is required.",
  [MISSING_COMPANY_NAME]: "Company name is required.",
};

export default class CommonValidator {
  static exists(value) {
    return !(angular.isUndefined(value) || value === null || value === "");
  }

  static doesNotExist(value) {
    return !this.exists(value);
  }

  static constructErrorMessage(errors) {
    const message = [];

    errors.forEach((error) => {
      message.push(COMMON_ERROR_MESSAGES[error]);
    });

    return message.join(" ");
  }
}



// WEBPACK FOOTER //
// ./client/app/services/validation/common.js